// extracted by mini-css-extract-plugin
module.exports = {"layout":"jl","content":"jm","a":"jn","footer":"jo"};